import React, { Fragment } from "react";
import { Container, Card, Row, Col} from "react-bootstrap";


const Brainteasers = () => { 


  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" style={{backgroundImage: 'url(/images/site/brainteaser.jpg)'}}>
        <h1 style={{color:'white'}}>Cognitive Brainteasers</h1>
      </div> 

      <Container fluid className="p-5">
        <Row>
         <p className="lead">Our brainteasers build specific cognitive thinking styles that have shown to improve creative thinking.
            Some kinds of thinking patterns that we focus on are:
         </p>
            <ul>
                  <li>
                     <span><b> Associative Thinking: </b></span> Associative thinking is the ability to combine unrelated ideas in a meaningful way.
                  </li>
                  <li>
                     <span><b> Analogical Thinking: </b></span> Analogical thinking involves identifying structural similarities between two concepts.
                  </li>
                  <li>
                     <span><b> Problem Finding: </b></span> Problem Finding refers to the ability to define your own problem to work on, a hallmark of higher creativity.
                  </li>

            </ul>
         </Row>
         <Row>
            <p className="lead">Below is a sampling of some of our brainteasers.
         </p>
         <Col className="col-12 col-md-4 mb-3">
            <Card className="border-warning">
               <Row>
                  <Col>
                  <img className="card-img-top img-fluid"
                     src="/images/challenges/Proverbial Tales-small.png"
                     height="100%"
                     width = "100%"
                     alt="Proverbial Tales"
                  />
                     
                  </Col>
                  <Col>
                     <p className="small"> <b> Level: </b> <span className="text-warning"> Medium </span></p>
                     <p className="small"> <b> Time: </b> 20 mins</p>
                  </Col>
               </Row>
               <Card.Body>
                  <Card.Title className="text-truncate">Proverbial Tales</Card.Title>
                  <Card.Text className="small">       
                     In Proverbial Tales, you have to make your own story based on a well known proverb. These brainteasers help build your analogical reasoning skills since you have to find ways to align your story with the meaning of the proverb. A good story arc includes the exposition, rising action, climax, falling action and denouement, so make sure to inlude these elements in your tale. 
                  </Card.Text>
                  
               </Card.Body>
            </Card>
         </Col>

         <Col className="col-12 col-md-4 mb-3">
            <Card className="border-success">
               <Row>
                  <Col>
                  <img className="card-img-top img-fluid"
                     src="/images/challenges/Wacky Inventions-small.png"
                     height="100%"
                     width = "100%"
                     alt="Wacky Inventions"
                  />
                     
                  </Col>
                  <Col>
                     <p className="small"> <b> Level: </b> <span className="text-success"> Easy </span></p>
                     <p className="small"> <b> Time: </b> 20 mins</p>
                  </Col>
               </Row>
               <Card.Body>
                  <Card.Title className="text-truncate">Wacky Inventions</Card.Title>
                  <Card.Text className="small">       
                     Wacky Inventions brainteasers are related to Chindogu, the Japanese art of unuseless inventions. Your ideas can be unusual and ridiculous (we encourage that!) as long as they do indeed solve a problem, or is worthy of an ignoble award. In this version, you will use two random objects to create your invention. These brainteasers help build associational thinking. 
                  </Card.Text>
                  
               </Card.Body>
            </Card>
         </Col>

         <Col className="col-12 col-md-4 mb-3">
            <Card className="border-warning">
               <Row>
                  <Col>
                  <img className="card-img-top img-fluid"
                     src="/images/challenges/Pose-a-Problem-small.png"
                     height="100%"
                     width = "100%"
                     alt="Pose-a-Problem"
                  />
                     
                  </Col>
                  <Col>
                     <p className="small"> <b> Level: </b> <span className="text-warning"> Medium </span></p>
                     <p className="small"> <b> Time: </b> 20 mins</p>
                  </Col>
               </Row>
               <Card.Body>
                  <Card.Title className="text-truncate">Pose-a-Problem</Card.Title>
                  <Card.Text className="small">       
                     In Pose-a-Problem, you get to create your own math problems based on the given situation. With these challenges, think of as many questions as you can and try to use different areas of mathematics while doing so. The ability to pose good questions is an indicator of exceptional talent in Mathematics.
                  </Card.Text>
                  
               </Card.Body>
            </Card>
         </Col>

         <Col className="col-12 col-md-4 mb-3">
            <Card className="border-success">
               <Row>
                  <Col>
                  <img className="card-img-top img-fluid"
                     src="/images/challenges/Opposite Day-small.png"
                     height="100%"
                     width = "100%"
                     alt="Opposite Day"
                  />
                     
                  </Col>
                  <Col>
                     <p className="small"> <b> Level: </b> <span className="text-success"> Easy </span></p>
                     <p className="small"> <b> Time: </b> 20 mins</p>
                  </Col>
               </Row>
               <Card.Body>
                  <Card.Title className="text-truncate">Opposite Day</Card.Title>
                  <Card.Text className="small">       
                     Opposite Day brainteasers work by identifying assumptions in a situation and then applying the "reversal" antix on them. After you reverse the assumption, you need to solve the challenge or in other words find a way to make the reversed assumption work well. You might be surprised at the new insights that you get! These brainteasers are based on the technique called "False Faces" in Michael Michalko's Thinkertoys.
                  </Card.Text>
                  
               </Card.Body>
            </Card>
         </Col>

         <Col className="col-12 col-md-4 mb-3">
            <Card className="border-success">
               <Row>
                  <Col>
                  <img className="card-img-top img-fluid"
                     src="/images/challenges/Word ORIGINals-small.png"
                     height="100%"
                     width = "100%"
                     alt="Word ORIGINals"
                  />
                     
                  </Col>
                  <Col>
                     <p className="small"> <b> Level: </b> <span className="text-success"> Easy </span></p>
                     <p className="small"> <b> Time: </b> 20 mins</p>
                  </Col>
               </Row>
               <Card.Body>
                  <Card.Title className="text-truncate">Word ORIGINals</Card.Title>
                  <Card.Text className="small">       
                     Word ORIGINals explores the etymological roots of a word or a phrase through a creative lens. Each brainteaser in this category provides the etymology of the word or phrase but you have the creative license to construct the story behind it. If your creative story incorporates the etymology, you will be more likely to remember this word and others with the same root.
                  </Card.Text>
                  
               </Card.Body>
            </Card>
         </Col>

         <Col className="col-12 col-md-4 mb-3">
            <Card className="border-warning">
               <Row>
                  <Col>
                  <img className="card-img-top img-fluid"
                     src="/images/challenges/Virtual History-small.png"
                     height="100%"
                     width = "100%"
                     alt="Proverbial Tales"
                  />
                     
                  </Col>
                  <Col>
                     <p className="small"> <b> Level: </b> <span className="text-warning"> Medium </span></p>
                     <p className="small"> <b> Time: </b> 20 mins</p>
                  </Col>
               </Row>
               <Card.Body>
                  <Card.Title className="text-truncate">Virtual History</Card.Title>
                  <Card.Text className="small">       
                     Virtual History is a form of historiography that attempts to answer "What If" questions about historical figures or events. It's a creative exercise that needs critical thinking skills to discover plausible alternate scenarios. These brainteasers build the skill of "perspective taking" while developing a richer understanding of history.
                  </Card.Text>
                  
               </Card.Body>
            </Card>
         </Col>

        </Row>

        

      </Container>

      
      

    </Fragment>
       
  );
};
  
  export default Brainteasers;